export default [
    {
        id: 1,
        title: "DuckDuckGo",
        coverImg: "duckduckgo.webp",
        route: "duckduckgo",

    },
    {
        id: 2,
        title: "Firefox",
        coverImg: "firefox.webp",
        route: "firefox",
    },
    {
        id: 3,
        title: "Telegram",
        coverImg: "telegram.webp",
        route: "telegram",
    },
]